import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/library/:libraryItemId/activities`;

export type GetLibraryItemActivitiesResponse = {
  status: boolean;
  data: any;
};

export type GetLibraryItemActivitiesDTO = {
  libraryItemId: number;
};

export type GetLibraryItemActivitiesParams = {
  page: number;
  inTrash?: boolean;
  limit: number;
};

export const getLibraryItemActivitiesQueryKey = {
  all: ['getLibraryItemActivities'] as const,
  list: (libraryItemId) => [...getLibraryItemActivitiesQueryKey.all, libraryItemId] as const,
};

export const getLibraryItemActivities = ({
  libraryItemId,
}: GetLibraryItemActivitiesDTO): Promise<GetLibraryItemActivitiesResponse> => {
  const URL = generateRoutePath(url, { libraryItemId });

  return axios.get(URL);
};
type QueryFnType = typeof getLibraryItemActivities;

type UseGetLibraryItemActivitiesOptions = {
  libraryItemId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetLibraryItemActivities = ({
  libraryItemId,
  config,
}: UseGetLibraryItemActivitiesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...getLibraryItemActivitiesQueryKey.all, libraryItemId],
    queryFn: () => getLibraryItemActivities({ libraryItemId }),
    // staleTime: Infinity,
    cacheTime: 0,
    ...config,
  });
};
